export default __webpack_public_path__ + "static/Live_Cams_05-b22152ba78386565af513d9ef01415ce.webp";